<template>
    <div>
        <div v-show="contentType== 0">
            <el-form ref="form" :inline="true" class="query-form" size="mini">
                <el-form-item class="query-form-item">
                    <el-form-item label="" prop="">
                        <el-radio-group v-model="query.switch">
                            <el-radio-button label="week">按周</el-radio-button>
                            <el-radio-button label="people">按人员</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="" prop="" v-show="query.switch == 'week'">
                        <el-date-picker v-model="query.date" type="week" format="yyyy 第 WW 周"
                                        :picker-options="{ firstDayOfWeek: 1 }" placeholder="选择周"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="人员：" class="query-form-item" v-show="query.switch == 'people'">
                        <el-select v-model="query.developer_id" placeholder="状态" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option :label="item.full_name" :value="item.id"
                                       v-for="item in developerList" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                      @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                      @selection-change="handleSelectionChange"
                      class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">


                <el-table-column label="周数" width="70" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.date }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="日期区间" width="270" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.begin_date }} ~ {{ scope.row.end_date }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="账号" min-width="140"  align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.username }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="人员" width="80" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.fullname }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="" width="120" align="center">
                    <template slot="header" slot-scope="scope">
                        <table-tool-tip column-txt="选品采购"
                                        tool-tip-con="
                                    指的是在指定时间区间内采购人员自建或者被分配的已完成成本分析的Asin新增数量(不同国家同Asin算多个)
                                        "/>
                    </template>

                    <template slot-scope="scope">
                        {{ scope.row.all_purchase }}
                        <span :style="{color: scope.row.purchase > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.purchase }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                                  v-show="scope.row.purchase > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="" width="120" align="center">
                    <template slot="header" slot-scope="scope">
                        <table-tool-tip column-txt="选品采购(已确认)"
                                        tool-tip-con="
                                        指的是选品采购中,<br/>
                                        确认了销售价格以及1688链接的数量.该值一定小等于选品采购的数量
                                       "/>
                    </template>

                    <template slot-scope="scope">
                        {{ scope.row.all_purchase_confirmed }}
                        <span :style="{color: scope.row.purchase_confirmed > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.purchase_confirmed }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                         v-show="scope.row.purchase_confirmed > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="" width="100" align="center">
                    <template slot="header" slot-scope="scope">
                        <table-tool-tip column-txt="完成采购"
                                        tool-tip-con="
                                    指的是在指定时间区间内采购人员完成采购的Asin新增数量，
                                        <br/>利润是否符合的判断是基于本条成本分析所得的1-9月利润(含税)是否大等于管理员设定的相应运输方式的最低利润要求。
                                        <br/>注:完成采购数量与选品采购数量没有必然联系，完成采购的产品可能在早期中就进行了选品。
                                        "/>
                    </template>

                    <template slot-scope="scope">
                        {{ scope.row.all_purchased }}
                        <span :style="{color: scope.row.purchased > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.purchased }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                                v-show="scope.row.purchased > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="完成采购(符合利润)" width="130" align="center">

                    <template slot-scope="scope">
                        {{ scope.row.all_purchased_profit }}
                        <span :style="{color: scope.row.purchased_profit > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.purchased_profit }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                                  v-show="scope.row.purchased_profit > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="完成采购(不符利润)" width="130" align="center">

                    <template slot-scope="scope">
                        {{ scope.row.all_purchased_noprofit }}
                        <span :style="{color: scope.row.purchased_noprofit > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.purchased_noprofit }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                         v-show="scope.row.purchased_noprofit > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="" width="100" align="center">
                    <template slot="header" slot-scope="scope">
                        <table-tool-tip column-txt="运营中"
                                        tool-tip-con="
                                    指的是在指定时间区间内运营人员在运营中的Asin新增数量，(不同国家同Asin算多个)。
                                        <br/>注:总数表示当前运营中状态的数量，新增数为时间区间内新增的数量(不计算不再运营的移除数量)。
                                        "/>
                    </template>

                    <template slot-scope="scope">
                        {{ scope.row.all_operating }}
                        <span :style="{color: scope.row.operating > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.operating }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                            v-show="scope.row.operating > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-for="item in runningStates"
                    :key="item.state"
                    :label="`运营中(${item.cn_state})`"
                    width="120"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ getOperatingValue(scope.row, item.state, 'all_operating') }}
                        <span
                            :style="{color: getOperatingValue(scope.row, item.state, 'operating') > 0 ? 'green' : ''}"
                            style="font-weight: bold"
                        >
                           ( {{ getOperatingValue(scope.row, item.state, 'operating') }}
                            <i
                                class="el-icon-top"
                                style="color: green; font-size: 13px;"
                                v-show="getOperatingValue(scope.row, item.state, 'operating') > 0"
                            ></i>
                           )
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="" width="100" align="center">
                    <template slot="header" slot-scope="scope">
                        <table-tool-tip column-txt="不再运营"
                                        tool-tip-con="
                                    指的是在指定时间区间内运营人员确定了不再运营的Asin新增数量。 "/>
                    </template>

                    <template slot-scope="scope">
                        {{ scope.row.all_no_operating }}
                        <span :style="{color: scope.row.no_operating > 0 ? 'green' : ''}" style="font-weight: bold">
                           ( {{ scope.row.no_operating }}<i class="el-icon-top" style="color: green; font-size: 13px;"
                                                            v-show="scope.row.no_operating > 0"></i> )
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :page-size="query.limit"
                           :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                           style="margin-top: 10px; display: flex;justify-content: end;"
                           layout="total, sizes, prev, pager, next">
            </el-pagination>
        </div>
        <statistical-details v-show="contentType == 1" ref="StatisticalDetails"
                             @goBackList="goBackList"></statistical-details>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import { getRunningStates } from '@/api/common/common.js'
import {downloadFileUrl} from '@/utils/method'
import StatisticalDetails from './statisticalDetails.vue'

let timer = null
export default {
    name: 'myChoice',
    components: {StatisticalDetails},
    computed: {
        showOperate() {
            return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
        },
        showToMe() {
            return this.$checkPermission('admin/cost_analysis/personal/assign_undistributed_self_build_to_me')
        },
    },
    data() {
        return {
            contentType: 0,
            categoryList: [],
            peopleListVisible: false,
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            runningStates: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            typeArr: [{
                index: 1,
                title: '广告层面'
            },
                {
                    index: 2,
                    title: '逻辑层面'
                }
            ],
            query: {
                switch: 'week',
                date: '',
                developer_id: '',
                page: 1,
                limit: 20,
                total: 0,
            },
            developerList: [],
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
        }
    },
    created() {
        this.query.date = new Date()
    },
    mounted() {
        this.getPeople()
        this.getRunningStates()
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        }
    },
    destroyed() {
        clearInterval(timer)
    },
    methods: {

        getRunningStates() {
            getRunningStates().then(res => {
                if (res && res.code === 0) {
                    this.runningStates = (res.data || []).map(item => ({
                        state: item.state,
                        cn_state: item.cn_state,
                    }))
                } else {
                    this.runningStates = []
                }
                this.getList()
            }).catch(() => {
                this.runningStates = []
            })
        },
        getOperatingValue(row, state, prefix) {
            const key = `${prefix}_${state}`
            const val = row ? row[key] : undefined
            // null/undefined 统一展示为 0
            return val === null || val === undefined ? 0 : val
        },

        goBackList() {
            this.contentType = 0
        },
        getPeople() {
            api.manager_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.developerList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getCategoryList() {
            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },

        detailFunc(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
        },
        // 取消分配
        unassignFunc(data) {
            api.cost_analysis_personal_cancel_assign({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('取消分配成功')
                    this.getList()
                } else {
                    this.$message.error('取消分配失败，请联系管理员')
                }
            })
        },
        // 操作
        operateFunc(data, type) {
            let tempDate = JSON.parse(JSON.stringify(data))
            this.editType = type
            this.copyData = tempDate
            this.showAddRecord = true
        },
        // 采购
        toMeFunc(data) {
            this.multipleSelection = [data.id]
            this.onBatchDistribution()
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        seeUrl(row) {
            this.childInfo.title = '1688链接'
            this.childInfo.info = row.href_link
            this.ctrl.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        jumpDetail(data, key) {
            if (data[key] == 0) {
                return
            }
            this.$refs.StatisticalDetails.getList(data[`${key}_ids`])
            console.log('data', data[key], key, data[`${key}_ids`])
            this.contentType = 1

        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        copyDataFunc(data, type) {
            this.showAddRecord = true
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
            tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
            this.editType = type
            this.copyData = tempDate
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.variety_cost_control_analysis_delete({ids: [data.id]}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.parsing_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getList() {
            this.loading = true
            let tempQuery = JSON.parse(JSON.stringify(this.query))
            if (tempQuery.switch == 'week') {
                tempQuery.developer_id = ''
                if (tempQuery.date !== '' && tempQuery.date !== null) {
                    tempQuery.date = this.dateToYearAndWeek(new Date(tempQuery.date))
                }
            } else {
                tempQuery.date = ''
            }
            api.manager_statistics_statistics_kpi_week(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },

        dateToYearAndWeek(date) {
            const year = date.getFullYear()
            const onejan = new Date(date.getFullYear(), 0, 1);
            const millisInYear = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(onejan.getFullYear(), onejan.getMonth(), onejan.getDate());
            let onejanDay = onejan.getDay();
            if (onejanDay == 0) onejanDay = 7;
            let week = Math.ceil((millisInYear / (86400000 * 7)) + onejanDay / 7);
            week =  week < 10 ? `0${week}` : week
            return `${year}${week}`
        },

        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                name: '',
                state: '',
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        onBatchDistribution() {
            if (this.multipleSelection.length > 0) {
                this.peopleListVisible = true
            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },

        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        // 关闭弹窗回调
        chooseDevelopCloseCallback(arr) {
            this.peopleListVisible = false
            if (arr.length > 0) {
                api.manager_cost_analysis_manager_batch_distribution({
                    ids: this.multipleSelection,
                    developer_id: arr[0]
                }).then(res => {
                    if (res.code === 0) {
                        this.$message.success('分配成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            }
        },
        refreshList() {
            this.getList()
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.canClick {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
}

.redTxt {
    color: red;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
